"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encryptString = exports.encryptEmail = exports.encryptIdCard = exports.encryptName = exports.encryptBankCard = exports.encryptPhone = void 0;
const hub_utilities_validate_1 = require("@yw/hub.utilities.validate");
function encryptPhone(phone) {
    if ((0, hub_utilities_validate_1.validatePhone)(phone)) {
        return phone.replace(/(\d{3})\d*(\d{4})/, '$1****$2');
    }
    return phone;
}
exports.encryptPhone = encryptPhone;
function encryptBankCard(bankCard) {
    if ((0, hub_utilities_validate_1.validateBankCard)(bankCard)) {
        return bankCard
            .replace(/\s/g, '')
            .replace(/(\d{4})\d+(\d{4})$/, '**** **** **** $2');
    }
    return bankCard;
}
exports.encryptBankCard = encryptBankCard;
function encryptName(name) {
    if ((0, hub_utilities_validate_1.validateName)(name)) {
        if (name.length <= 3) {
            return `*${name.substring(1, name.length)}`;
        }
        if (name.length > 3 && name.length <= 6) {
            return `**${name.substring(2, name.length)}`;
        }
        if (name.length > 6) {
            return `${name.substring(0, 2)}****${name.substring(6, name.length)}`;
        }
    }
    return name;
}
exports.encryptName = encryptName;
function encryptIdCard(idCard) {
    if ((0, hub_utilities_validate_1.validateIDCard)(idCard)) {
        if (idCard.length === 18) {
            return idCard.replace(/^(\d{3})\d{12}((\d|[Xx]){3})$/, '$1************$2');
        }
        // 对于15位身份证号码，将第7到第12个字符用"****"替换
        if (idCard.length === 15) {
            return idCard.replace(/^(\d{3})\d{9}((\d|[Xx]){3})$/, '$1*********$2');
        }
        // 身份证号码格式不正确，直接返回原值
        return idCard;
    }
    return idCard;
}
exports.encryptIdCard = encryptIdCard;
function encryptEmail(email) {
    if ((0, hub_utilities_validate_1.validateEmail)(email)) {
        const result = email.split('@');
        const name = result[0];
        const host = result[1];
        return `${name.slice(0, 3)}***@${host}`;
    }
    return email;
}
exports.encryptEmail = encryptEmail;
function encryptString(config) {
    const rawValue = String(config.value);
    const encryptLen = rawValue.length - config.prefix - config.suffix;
    if (encryptLen > 0) {
        const encryptString = '*'.repeat(encryptLen);
        return rawValue.replace(new RegExp(`(\.{${config.prefix}})\.+(\.{${config.suffix}})$`), `$1${encryptString}$2`);
    }
    return rawValue;
}
exports.encryptString = encryptString;
//# sourceMappingURL=cryptr.js.map